import './terms-html.scss';

/**
 * 利用規約バージョン
 *
 * ・規約本文の内容と必ずセットで更新すること
 * ・API や外部ファイルからは取得せず、本ファイル内でベタ管理する方針
 * ・形式は `YYYY-MM-DD-rN`（日付 + リビジョン）とする
 *   例: 2026-01-20-r1
 */
export const TERMS_VERSION = '2026-02-01-r1';
/**
 * 利用規約本文（表示用）
 *
 * ・規約本文は JSX としてベタ書きで管理する
 * ・規約更新時は本文修正と TERMS_VERSION の更新を同時に行うこと
 */
export const termsHtml: JSX.Element = (
  <div className="terms-content">
    <h1>インターネット発注システム（PPMクラウド）利用規約</h1>
    <p>
      この規約は、株式会社ラボネットワーク（以下「当社」といいます。）が提供する、オンラインで写真データを受け付け、写真・アルバム等の出力を受注するインターネット受注システム「PPMクラウド」（以下「本システム」といいます。）を、法人または事業者である利用者（以下「利用者」といいます。）が利用する際の条件を定めるものです。利用者は、当社の提供する写真関連商材（以下「当社商品」といいます。）について、本システムを利用することでインターネットを通じて注文いただけるようになります。利用者は、本規約に同意のうえで、本システムを利用するものとし、同意がいただけない場合は本システムを利用できません。
    </p>
    <h2>第１条（適用範囲）</h2>
    <ol className='term-list'>
      <li>
        本規約は、当社と取引基本契約を締結した利用者を対象に、本システムを利用した受発注取引に適用されるものとします。
      </li>
      <li>
        本システムを利用した受発注取引について、取引基本契約書と本規約に矛盾がある場合には、利用者と当社との間で別段の合意がある場合を除き、本規約が優先して適用されるものとします。
      </li>
    </ol>
    <h2>第２条（利用申込）</h2>
    <ol className='term-list'>
      <li>
        本システムをご利用いただく前提として、利用者は当社との間で、当社商品に関する取引基本取引契約を締結する必要があります（以下、かかる契約を「基本契約」といいます）。
      </li>
      <li>
        利用者は、本システムの利用に必要な申込みを行う場合には、事前に又は同時に取引基本契約書を締結することが必要です。
      </li>
    </ol>
    <h2>第３条（アカウント及びパスワードの管理）</h2>
    <ol className='term-list'>
      <li>
        利用者は、基本契約の締結と同時に当社が発行するアカウント、パスワードにより、本システムの利用が可能になります。当社は、アカウントとパスワードの組み合わせが登録情報と一致してログインされた場合には、当該アカウントを登録しているユーザー自身による利用とみなします。
      </li>
      <li>
        利用者は、発行されたアカウント、パスワード等を善良な管理者の注意をもって管理し、漏えいさせてはならず、第三者に使用させてはなりません。
      </li>
      <li>
        利用者によるアカウント・パスワード管理不備により損害が生じたとしても、当社は責任を負いません。
      </li>
    </ol>
    <h2>第４条（本システムの運用）</h2>
    <ol className='term-list'>
      <li>
        本システムは、当社商品をご注文いただくための、データの作成、画像データの一時保存、製造指示、注文、ステータス管理等の機能を提供します。
      </li>
      <li>
        当社商品をご注文いただくための使用に限り、本システムは無償でご利用いただけます。当社商品のご注文以外の目的に、本システムを利用することはできません。
      </li>
      <li>
        当社は、次の各号のいずれかに該当する場合、利用者に事前に通知することなく、本システムの全部又は一部を停止することができます。
        <ol className="term-sub-list">
          <li>本システムの点検又は保守を定期的または緊急に行う場合</li>
          <li>本システムに負荷が集中した場合</li>
          <li>不正アクセス、サイバー攻撃の発生等、利用者のセキュリティを確保する必要が生じた場合</li>
          <li>コンピュータ、通信回線等が、事故、天災地変、停電等により停止した場合</li>
          <li>前各号のほか、本システムの停止が必要であると、当社が合理的に判断した場合</li>
        </ol>
      </li>
      <li>
        当社は、当社が必要と判断する場合、廃止日の６カ月前までに利用者に通知することにより、本サービスの一部又は全部を変更又は廃止することができるものとします。
      </li>
    </ol>
    <h2>第５条（注文データの取り扱い）</h2>
    <ol className='term-list'>
      <li>
        当社は、本システムの提供、および出力物の生産、および製造された商品の不適合に対応するために必要な範囲で、利用者の注文データを保存します。
      </li>
      <li>
        注文済みのデータは、納品完了後から商品の不適合に対応するために設定される一定期間を経過後に順次、自動で消去されます。
      </li>
      <li>
        当社で保管するデータについては、サービス提供に必要な範囲で適切なバックアップを実施しますが、完全な復旧を保証するものではありません。万一のデータ消失についての補償は出来ませんので、利用者側の責任で適切なバックアップをお願いいたします。
      </li>
    </ol>
    <h2>第６条（個人情報の取扱い）</h2>
    <ol className='term-list'>
      <li>
        当社は、本システムの提供にあたり、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）及び当社の個人情報保護方針に従って、利用者が本システムを通じて提供した個人情報（個人情報保護法において定義される「個人情報」をいいます。）を、適正に取り扱います。
      </li>
    </ol>
    <p className="terms-link">
      <a
        href="https://www.labonetwork.co.jp/privacy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        個人情報保護方針 │ 株式会社ラボネットワーク
      </a>
    </p>
    <h2>第７条（知的財産権）</h2>
    <ol className='term-list'>
      <li>
        本システムのソフトウェア、デザインテンプレート、ドキュメント等にかかる著作権、産業財産権その他一切の知的財産権は当社に帰属します。
      </li>
      <li>
        利用者は、送信した注文データに含まれる画像データを、利用者が指定した商品の製造販売を目的とする範囲内において、当社が複製、加工、編集又は改変する権利を無償で非独占的に許諾するものとします。
      </li>
      <li>
        注文データに含まれる知的財産権は、利用者または正当な権利者に帰属し、当社は利用者に指示された製品の製造販売以外の目的に、利用者の注文データを利用しません。
      </li>
    </ol>
    <h2>第８条（禁止行為・アカウント管理）</h2>
    <ol className='term-list'>
      <li>
        利用者は、次の行為を行ってはなりません。
        <ol className="term-sub-list-kakko">
          <li>法令・公序良俗に反するデータの送信</li>
          <li>著作権・肖像権等の第三者の権利を侵害するデータの送信。</li>
          <li>システムに過度な負荷を与える行為、脆弱性の探索、不正アクセス</li>
          <li>当社または第三者の権利または利益を侵害する行為</li>
          <li>当社のサービスに関連して、反社会的勢力に対して直接又は間接に利益を供与する行為</li>
        </ol>
      </li>
      <li>
        利用者は、アカウント・パスワード管理において、以下の行為を行ってはなりません。
        <ol className="term-sub-list-kakko">
          <li>アカウント・パスワード等の情報を不正に使用し、または第三者に使用させる行為</li>
          <li>第三者になりすまして本サービスを利用する行為</li>
          <li>他の利用者のアカウント・パスワード等の情報を不正に取得・利用する行為</li>
          <li>アカウント・パスワード等の情報を第三者に譲渡、貸与、共有する行為</li>
        </ol>
      </li>
      <li>
        利用者は、アカウント・パスワード等の情報が漏えいしたり、第三者に使用されたりしていることが判明した場合は、直ちに当社に通知し、当社からの指示に従うものとします。
      </li>
      <li>
        当社は、利用者が第1項及び第2項に違反する場合又は第1項又は第2項各号のいずれかに該当し、もしくは該当するおそれがあると当社が判断した場合には、利用者に事前に通知することなく、本システムの利用の停止、その他の措置を講じることができるものとします。
      </li>
    </ol>
    <h2>第９条（免責事項）</h2>
    <ol className='term-list'>
      <li>
        本システムは、常に無停止・無欠陥であること、注文データが完全であること、成果物の色再現の同一性が確保されていること等を保証するものではありません。
      </li>
      <li>
        注文データの適法性・正確性・権利処理は、利用者が一切の責任を負うものとします。
      </li>
      <li>
        当社は、天災、停電、通信障害、クラウド基盤障害、疫病、行政指導、配送事故等の不可抗力に起因する製造不能や遅延についての責任を負いません。
      </li>
      <li>
        当社が公序良俗に反するデータと判断される注文データを受信した場合には、出力物の製造をお断りする場合があります。
      </li>
      <li>
        当社が利用するサーバー、ネットワーク等のインフラ設備の不具合、電気通信事業者の提供するサービスの停止、または第三者による不正アクセス等、当社の合理的な支配の及ばない事由によりデータ流出等が生じた場合、当社は、故意または重大な過失が認められる場合を除き、一切の責任を負いません 。
      </li>
      <li>
        前項にかかわらず、当社は、本システムの利用に関連して利用者が登録、送信、または保存したデータの滅失、毀損、または外部への流出が発生した場合、当社に故意または重大な過失が認められる場合を除き、これによって利用者または第三者に生じた損害について一切の責任を負いません。
      </li>
      <li>
        利用者が本規約に定めるアカウント情報の管理を怠ったこと、または本規約に違反して第三者にアカウントを利用させたことによりデータ流出等が生じた場合、当社は一切の責任を負いません。
      </li>
    </ol>
    <h2>第１０条（権利義務の譲渡）</h2>
    <p className='term-single'>
      利用者は、当社の事前書面承諾なく、利用契約上の地位または権利義務を第三者に譲渡してはなりません。当社は、事業譲渡・会社分割等に伴い、本システムの提供主体を変更する場合があります。
    </p>
    <h2>第１１条（連絡方法）</h2>
    <ol className='term-list'>
      <li>
        本システムに関する当社から利用者への連絡は、当社から利用者への電子メールの送信、当社所定のウェブサイトへの掲示、又は本システム上の管理画面上での表示等、当社が適切と認める方法により行うものとします。
      </li>
      <li>
        当社が電子メールの送信による通知を行った場合、当社からの通知は、当該メールが通常到達すべきときに到達したものとみなします。
      </li>
    </ol>
    <h2>第１２条（本規約の変更）</h2>
    <ol className='term-list'>
      <li>
        当社は以下の場合など、当社が必要と認めた場合、本規約を変更することができます。
        <ol className="term-sub-list-kakko">
          <li>本規約の変更が、利用者の一般の利益に適合するとき</li>
          <li>本規約の変更が、利用者が契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更に係る事情に照らして合理的なものであるとき</li>
          <li>法令等の改正、本システムの変更等、やむを得ない事情が生じたとき</li>
        </ol>
      </li>
      <li>
        当社は、本規約を変更する場合には、その施行日の２週間前までに（やむを得ない場合にあっては速やかに）、第１１条第１項に規定するいずれかの方法により利用者に連絡するものとします。
      </li>
    </ol>
    <p className='term-supplement'>
      付則２０２６年２月１日　制定・施行
    </p>
  </div>
);
